export class LoadDto {
  id?: number;
  registerDate?: Date;
}
